import {
  ITEM_CARD_NARRATIVE_LIST_VIEW,
  ITEM_CARD_SEQUENCE_LIST_VIEW,
  MINDMAP_VIEW,
  NARRATIVE_VIEW,
  RELATIONSHIP_VIEW,
  TIMELINE_VIEW
} from "../constants/identifiers";
import { mindmapViewSettingsOperations } from "../modules/definition/mindmapViewSettings";
import { mobileItemCardViewSettingsOperations } from "../modules/definition/mobileItemCardViewSettings";
import { narrativeViewSettingsOperations } from "../modules/definition/narrativeViewSettings";
import { relationshipViewSettingsOperations } from "../modules/definition/relationshipViewSettings";
import { timelineViewSettingsOperations } from "../modules/definition/timelineViewSettings";

const getViewSettingsAndOperationsOfActiveViewType = ({
  activeViewType,
  timelineViewSettings,
  relationshipViewSettings,
  narrativeViewSettings,
  mindmapViewSettings,
  mobileItemCardViewSettings
}) => {
  let operations, viewSettings;
  switch (activeViewType) {
    case TIMELINE_VIEW:
      operations = timelineViewSettingsOperations;
      viewSettings = timelineViewSettings;
      break;
    case RELATIONSHIP_VIEW:
      operations = relationshipViewSettingsOperations;
      viewSettings = relationshipViewSettings;
      break;
    case NARRATIVE_VIEW:
      operations = narrativeViewSettingsOperations;
      viewSettings = narrativeViewSettings;
      break;
    case MINDMAP_VIEW:
      operations = mindmapViewSettingsOperations;
      viewSettings = mindmapViewSettings;
      break;
    case ITEM_CARD_SEQUENCE_LIST_VIEW:
    case ITEM_CARD_NARRATIVE_LIST_VIEW:
      operations = mobileItemCardViewSettings;
      viewSettings = mobileItemCardViewSettingsOperations;
      break;
  }
  return { operations, viewSettings };
};

export { getViewSettingsAndOperationsOfActiveViewType };
